export const SKIP_PREFLIGHT_CHECK=true
export const REACT_APP_MOBILE_BREAKPOINT_SIZE=768
export const REACT_APP_ASIDE_MINIMIZE_BREAKPOINT_SIZE=1024
export const REACT_APP_META_DESC="Apt Strata is a boutique Strata Management company established in 2019 by an accredited Body Corporate specialist. It is based upon the principles of value and service, transforming the currently stagnant Body Corporate industry."

export const REACT_APP_MODERN_DESGIN=true
export const REACT_APP_ASIDE_TOUCH_STATUS=true

export const REACT_APP_DARK_MODE=false

export const REACT_APP_ASIDE_WIDTH_PX=195
export const REACT_APP_SPACER_PX=13

export const REACT_APP_PRIMARY_COLOR="#6c5dd3"
export const REACT_APP_SECONDARY_COLOR="#ffa2c0"
export const REACT_APP_SUCCESS_COLOR="#46bcaa"
export const REACT_APP_INFO_COLOR="#4d69fa"
export const REACT_APP_WARNING_COLOR="#ffcf52"
export const REACT_APP_DANGER_COLOR="#f35421"
export const REACT_APP_LIGHT_COLOR="#e7eef8"
export const REACT_APP_DARK_COLOR="#1f2128"
